import React from 'react';
import { motion } from 'framer-motion';
import { Music, Brain, Heart } from 'lucide-react';
export function MechanismSection() {
  return <section className="bg-slate-800 py-24 px-4 text-slate-100" data-id="element-68">
      <div className="max-w-5xl mx-auto" data-id="element-69">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-70">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-71">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif" data-id="element-72">
              El Método{' '}
              <span className="text-amber-400" data-id="element-73">"Sinfonía del Descanso"</span>
            </h2>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-74">
              A diferencia de las pastillas que "apagan" tu cerebro a la fuerza,
              este método trabaja CON tu biología, no contra ella.
            </p>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-75">
              Aprenderás a usar anclajes de relajación y ritmos biológicos que
              le envían un mensaje claro y poderoso a tu sistema nervioso:
            </p>

            <div className="bg-amber-500/10 border-l-4 border-amber-500 p-6 rounded-r-xl mb-8" data-id="element-76">
              <p className="text-2xl font-serif italic text-amber-200" data-id="element-77">
                "Estás segura. Puedes descansar."
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="grid gap-6" data-id="element-78">
            {[{
            icon: <Brain className="w-8 h-8 text-amber-400" data-id="element-79" />,
            title: 'Reprogramación Suave',
            desc: "Cambia la asociación de tu cama: de 'lugar de estrés' a 'santuario de paz'."
          }, {
            icon: <Heart className="w-8 h-8 text-amber-400" data-id="element-80" />,
            title: 'Calma el Sistema Nervioso',
            desc: 'Técnicas específicas para bajar las revoluciones después de los 60 años.'
          }, {
            icon: <Music className="w-8 h-8 text-amber-400" data-id="element-81" />,
            title: 'Ritmos Biológicos',
            desc: 'Sincroniza tu reloj interno con los ciclos naturales de luz y oscuridad.'
          }].map((item, idx) => <div key={idx} className="bg-slate-700/50 p-6 rounded-xl border border-slate-600 hover:border-amber-500/50 transition-colors" data-id="element-82">
                <div className="flex items-start gap-4" data-id="element-83">
                  <div className="bg-slate-800 p-3 rounded-lg shadow-lg" data-id="element-84">
                    {item.icon}
                  </div>
                  <div data-id="element-85">
                    <h3 className="text-xl font-bold text-amber-100 mb-2" data-id="element-86">
                      {item.title}
                    </h3>
                    <p className="text-slate-300" data-id="element-87">{item.desc}</p>
                  </div>
                </div>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}